import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import en from "../../util/locales/en";
import ar from "../../util/locales/ar";

const SortOption = {
  YEARS_HIGH_TO_LOW: "years-high-to-low",
  YEARS_LOW_TO_HIGH: "years-low-to-high",
};

const SortSelector = ({ selectedSort, onSortChange }) => {
  const language = useSelector((state) => state.language);
  const t = language === "en" ? en : ar;

  const handleSortChange = (e) => {
    onSortChange(e.target.value);
  };

  return (
    <StyledSortSelector language={language}>
      <div className="sort-container">
        <select
          id="sort-select"
          value={selectedSort}
          onChange={handleSortChange}
          className="sort-select"
        >
          <option value={SortOption.YEARS_HIGH_TO_LOW}>
            {t.carFinance.result.yearsHighToLow || "Years: High to Low"}
          </option>
          <option value={SortOption.YEARS_LOW_TO_HIGH}>
            {t.carFinance.result.yearsLowToHigh || "Years: Low to High"}
          </option>
        </select>
      </div>
    </StyledSortSelector>
  );
};

const StyledSortSelector = styled.div`
  .sort-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    direction: ${(props) => (props.language === "ar" ? "rtl" : "ltr")};
  }

  label {
    margin-right: ${(props) => (props.language === "ar" ? "0" : "10px")};
    margin-left: ${(props) => (props.language === "ar" ? "10px" : "0")};
    font-size: 14px;
    color: #555;
  }

  .sort-select {
    padding: 8px 12px;
    border-radius: 6px;
    border: 1px solid #E4E6E8;
    background-color: white;
    font-size: 14px;
    min-width: 160px;
    appearance: auto;
    cursor: pointer;
    transition: all 0.2s ease;
    height: 40px;

    &:hover,
    &:focus {
      outline: none !important;
      box-shadow: none !important;
    }
  }
`;

export { SortSelector, SortOption };
